<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="流程名称">
                    <c-input name="processName"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-select name="invokes" :options="disableEnableDic" ></c-select>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_workflow_design_edit')" prepend-icon="tf-add" @click="add">新建</c-button>
            </m-operate>

            <c-table ref="list" height="grow">
                <c-table-column
                        label="流程名称"
                        name="processName"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="所属对象"
                        name="objectModelName"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="createrName"
                >
                    <template #default="{data}">
                        <span >{{data.createrName}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="createDate"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="启禁用"
                        name="invoke"
                        width="100"
                >
                    <!--启禁用状态-->
				    <template #default="{data}">
                        <c-switch v-if="auth('b_workflow_design_edit')" v-model="data.invoke" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.invoke"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_workflow_design_edit')"  icon="tf-related" @click="design(data)">设计</c-table-button>
                        <c-table-button v-if="auth('b_workflow_design_edit')"  icon="tf-copy" @click="copy(data)">复制</c-table-button>
                        <c-table-button v-if="auth('b_workflow_design_edit')"  icon="tf-edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_workflow_design_edit')"  icon="tf-trash" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!-- 编辑弹窗 -->
            <design-edit ref="designEdit" @resolve="$refs.list.update()"></design-edit>
        </module>
        <!-- 添加设计弹窗 -->
        <c-dialog
                ref="designDialog"
                title="流程设计"
                width="100vw-300"
                mode="slide"
                :button="false"
                @close="closeDesign"
        >
            <iframe
                    v-if="designUrl"
                    :src="designUrl"
                    frameborder="0"
                    width="100%"
                    height="100%"
                    style="display: block; border: none;"
            ></iframe>
        </c-dialog>
    </page>
</template>

<script>
import {mapState} from "vuex";
import designEdit from "@/pages/workflow/workflow_design_edit.vue";

export default {
    components: {
        designEdit

    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['session','disableEnableDic']),
    },

    data() {
        return {
            designUrl: '',  // 存储iframe的URL
            currentDesignData: null,  // 当前设计的数据
            designHost: '',
        }
    },

    mounted() {
        this.searchHandle();

        this._message = ({origin, data: {event, data}}) => {
            if (origin == window.origin) return;
            console.log('workflow set:', event, data);
            if (event == 'ready') {
                this.postMessage({
                    event: 'login',
                    data: this.session
                });
            }
        }
        window.addEventListener('message', this._message);
    },

    beforeDestroy() {
        window.removeEventListener('message', this._message);
    },

    methods: {
        postMessage(data) {
            const iframe = this.$refs.designDialog.$el.querySelector('iframe');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(data, /^https?:\/\/[^/]+\//.exec(this.designUrl)[0]);
            }
        },
        /************搜索列表**************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            this.$refs.list.load({
                url: '/flow/workflow/list',
                data
            });
        },

        /******用户启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/flow/workflow/edit_invoke',
                data: {
                    processId: data.id,
                    invoke: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },
        /** 新建 */
        add() {
            this.$refs.designEdit.open();
        },
        /** 设计 */
        design(data){
            this.currentDesignData = data;
            this.designHost = data.designHost;
            this.designUrl = `${this.designHost}/workflow/to_design.html?id=${data.id}&workflowName=${data.processName}&modelId=${data.objectModelId}&fileUploadState=false&phoneInvoke=false&parent=${encodeURIComponent(window.origin)}`;
            // 打开弹窗
            this.$refs.designDialog.open();
        },

        /** 关闭设计弹窗 */
        closeDesign() {
            this.designUrl = '';
            this.currentDesignData = null;

            // 可选：刷新列表数据
            this.searchHandle();
        },
        /** 复制 */
        copy(data){
            this.request({
                url: '/flow/workflow/copy',
                data: {
                    processId: data.id
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    this.searchHandle();
                }
            })
        },
        /** 编辑 */
        edit(data){
            this.$refs.designEdit.open(data);
        },
        /** 删除 */
        remove(data){
            this.$confirm({
                message: '确定要删除吗？',
                resolve: () => {
                    this.request({
                        url: '/flow/workflow/remove',
                        data: {
                            processId: data.id
                        },
                        success: (data, message) => {
                            this.$message({
                                message: message,  // 提示内容,
                                type: 'success'
                            });
                            this.searchHandle();
                        }
                    })
                },
                cancel: () => {
                }
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>